import React, { ChangeEvent, useCallback, useMemo, useState } from "react";
import Button from "../Button";

export interface BidProps {
  minBid: number;
  onClick: (amount: number, quantity: number) => void;
  placementNote?: string;
  activeBid?: boolean;
}
const Bid = ({ minBid, onClick, placementNote, activeBid }) => {
  const [value, setValue] = useState<string>(minBid);
  const [isConfirming, setIsConfirming] = useState(false);

  const onBidChange = (e: ChangeEvent<HTMLInputElement>) => {
    const changedValue = e.target.value.replace(/[^0-9]/g, "");
    setValue(changedValue);
  };
  const onBidBlur = (e) => {
    const enteredValue = parseFloat(e.target.value);
    if (!enteredValue || enteredValue < minBid) {
      setValue(minBid);
      return;
    }
  };

  const [buttonBgColor, buttonTextColor] = useMemo(() => {
    if (isConfirming) {
      return ["bg-black", "text-white"];
    }

    return ["", ""];
  }, [isConfirming]);

  const onBidClick = useCallback(() => {
    if (!isConfirming) {
      setIsConfirming(true);
      return;
    }
    const numValue = parseFloat(value);
    setIsConfirming(false);
    onClick(numValue, 1);
  }, [isConfirming]);

  return (
    <div className="flex flex-col py-[65px]">
      {!!placementNote && (
        <div className="text-center text-auctionMid text-[18px] mb-[20px]">
          {placementNote}
        </div>
      )}
      <div className=" border border-auctionStroke text-[34px]  text-center flex-row mb-[16px] ">
        <span>$</span>
        <input
          type="text"
          pattern="\d*"
          size={value?.toString().length ? value.toString().length : 1}
          value={value}
          onChange={onBidChange}
          onBlur={onBidBlur}
          className="max-w-[100%] p-[5px] min-h-[84px]"
        />
      </div>

      <Button
        buttonClassName={buttonBgColor}
        textClassName={buttonTextColor}
        onClick={onBidClick}
        label={
          !!activeBid
            ? "update bid"
            : !isConfirming
            ? "place bid"
            : "confirm bid"
        }
      />
    </div>
  );
};

export default Bid;
